const {fr} = require("date-fns/locale");
const { registerLocale, setDefaultLocale } = require("react-datepicker");

registerLocale('fr', fr);
setDefaultLocale('fr');

module.exports = {
  "search_placeholder": {
    "fr": "Rechercher"
  },
  "info_traffic_title": {
    "fr": "Toute l'info trafic"
  },
  "notifications_service_endpoint": "https://apim.keolis.com/KWP000/notification",
  "last_news_label": {
    "fr": "Actualités"
  },
  "date_format": {
    "fr": "dd/MM/yyyy"
  },
  "mapbox_token": "pk.eyJ1IjoibWltaXJvc2UyOSIsImEiOiJjbGV3cHhsaGgxMHV2NDNtazAxOGM0MXhrIn0.LieDdLfJevyJ6njBc9-vQg",
  "display_contact": false,
  "side_blocks": {
    "fr": [
      "42035029"
    ]
  },
  "fb_display": false,
  "api_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MjI3MDA0NzQsImV4cCI6MTY1NDIzNjQ3NCwidXNlcm5hbWUiOiIzOSJ9.zwtl76to23UQCkU0YZ2_nXhraXHiTecT01Jm2jCqEi8J6DDWtuU7ZSKIsHcmLkeBq7vp5EDQZgnemlEV9hwp-lLZ6bsTeqju0PmZO2c0I3DxDAKtqr5xHMtDW1qwqXTo6rs0CiAyFpYNkIoWQOK2Um7B19Vf4x5wMHhA76FOLcRTX1KmiJtShv6jekXdGqzusQjxFBgEacZJcHrbA58i0l-s-uyPxNV6i9wm9NWwHiVcziZdeqspNs1gGEkJYpfyqFYsnmUf7T31gGtK0RtOyjvAoPCuWVCMdNi-jgHdbTkMNTJ6IM2flKhR0LcBk-4Vqr9rEJcA8rHOxIPmPffVVy0XBAoLE3Zw5u9jgpv4saONqCVubw1y6Ix9DKfa_gNTbYcrVD9ZGcQph882nNY5hBgAuHt7PuJgNhKGVHrxs2_hHs3KzxW2ZxlpbgB56MfvV85V8qTzHfckAOuV2HKzUGze2bdcaVrLVOJAgziZRymqpkSfSLmc0rCsiAPUb5JVr66GguTiZefoj4A-riya71-HaCovKaZOO6gFT_vJy84LC1qI1M7T64pb-CcPymQDsrH_SvOVFdZNhPzsbDkU8EaPw6J5csO4_OjlGpINOlYkdA5BWQUBgEFBXkZcIGMv9Zmcp-xTewP4j1RGRnY7YeeIoyNw-uv3HfWF6T5fzE0",
  "serverless_sendmail_endpoint": "https://apim.keolis.com/dato/send/form",
  "api_url": "https://api-v2.mobireport.fr",
  "website_name": "Keolis Bourgogne",
  "time_format": {
    "fr": "HH:mm"
  },
  "twitter_display": false,
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/KWP000/file/import",
  "news_redirect_label": {
    "fr": "Lire l'actualité"
  },
  "search_title": {
    "fr": "Recherche"
  },
  "contact_label": {
    "fr": "Renseignements"
  },
  "info_traffic_slug": {
    "fr": "toutes-les-infos-trafic"
  },
  "search_button_label": {
    "fr": "Rechercher"
  },
  "contact_phone_number": {
    "fr": "03 80 74 12 12"
  },
  "info_traffic_detail_slug": {
    "fr": "Détail de l'info trafic"
  },
  "notifications_service_token": "1142321004f3407b98a95856f9820607",
  "primary_color": {
    "red": 0,
    "green": 95,
    "blue": 125,
    "alpha": 255
  },
  "serverless_sendmail_token": "1142321004f3407b98a95856f9820607",
  "no_search_label": {
    "fr": "Veuillez saisir des termes et valider pour lancer la recherche"
  },
  "gradient_primary_color": {
    "red": 0,
    "green": 151,
    "blue": 198,
    "alpha": 255
  },
  "alt_text": {
    "fr": "Renseignements : 03 80 74 12 12"
  },
  "info_traffic_content_title": {
    "fr": "L'information trafic"
  },
  "redirection_button_text": {
    "fr": "+ D'INFOS"
  },
  "search_icon_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 1
  },
  "search_in_progress_label": {
    "fr": "Recherche en cours..."
  },
  "search_no_results_label": {
    "fr": "Il n'y a aucun résultat pour cette recherche"
  },
  "gradient_button_color": {
    "red": 12,
    "green": 125,
    "blue": 123,
    "alpha": 255
  },
  "active_button_text_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "search_error_label": {
    "fr": "Une erreur s'est produite, veuillez réessayer dans quelques minutes"
  },
  "search_token": "04011d69bc50aeb9129e45a882d573",
  "secondary_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "subsidiary_logo": {
    "path": "/50727/1693216026-keolis_bourgogne_blanc.png",
    "format": "png",
    "size": 33815,
    "alt": "Logo Keolis Bourgogne",
    "title": "Keolis Bourgogne",
    "width": 1733,
    "height": 563
  },
  "back_to_home_title": {
    "fr": "Keolis Bourgogne – revenir à la page d'accueil"
  },
  "language_selector_title": {
    "fr": "Changer la langue"
  },
  "piano_site_id": "639245",
  "google_tag_manager_id": "GTM-KF5W8RV",
  "google_analytics_key": "",
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "actistat_key": "",
  "loader": {
    "path": "/50727/1693496481-loader-bleu-utilisateur.gif",
    "format": "gif",
    "size": 830108,
    "alt": "Page en chargement, veuillez patientez s'il vous plaît",
    "title": "Page en chargement",
    "width": 1080,
    "height": 1080
  },
  "api_url_get_lines_endpoint": "/public/line",
  "api_url_user_registration_endpoint": "/public/customer",
  "scripts": [],
  "form_captcha_key": "6Lcd1DMjAAAAAEsHVSyCqBSA_c8IBpjJStjgY_pH",
  "updated_at": "2026-02-26T10:01:11.459+01:00",
  "created_at": "2020-12-29T15:46:21.809+01:00",
  "locale": "fr",
  "locales": [
    "fr"
  ],
  "siteUrl": "https://www.keolisbourgogne.com/",
  "readOnlyApi": "c788c13ffae157ace467efe109a1cb"
}